import React from "react";

function OOPS() {
  return (
    <div py-12 bg-gray-50>
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-screen-xl lg:px-8 mt-12">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
            <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">
              OOPS
            </h2>
            <h1 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
              Object Oriented Programming
            </h1>
            <p className="mt-4 text-lg leading-6 text-gray-500">
              This resource covers the fundamentals of Object Oriented
              Programming, including classes, objects, inheritance,
              polymorphism, and more.
            </p>
            <div className="mt-6">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.w3schools.com/cpp/cpp_oop.asp"
                className="inline-flex bg-indigo-500 border border-transparent rounded-md font-semibold text-white hover:bg-indigo-600 active:bg-indigo-700 px-4 py-2 text-base shadow-md
          transition duration-150 ease-in-out"
              >
                Learn more
              </a>
            </div>
          </div>
          <div className="mt-12 lg:mt-0 lg:col-span-6">
            <div className="max-w-md mx-auto">
              <img
                className="object-cover object-center rounded-lg shadow-lg"
                // src="https://pixabay.com/illustrations/cyber-security-technology-network-3374252/"
                src={require("../../images/oops.png")}
                alt="CNS"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <hr className="mt-8" />
      </div>
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <h1 className="text-2xl font-semibold text-gray-900">
            OOPS Resources
          </h1>
          <div className="mt-6 sm:mt-8">
            <ul className="divide-y divide-gray-200">
              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Object-Oriented Programming Concepts
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the basic concepts of Object-Oriented
                      Programming (OOP) such as classes, objects, inheritance,
                      polymorphism, and more.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.geeksforgeeks.org/object-oriented-programming-oops-concept-in-java/"
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>
              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Encapsulation
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the concept of encapsulation in OOP,
                      which is the process of binding data members and methods
                      into a single unit called a class.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.tutorialspoint.com/java/java_encapsulation.htm"
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>
              {
                <li className="py-4">
                  <div className="flex space-x-3">
                    <div className="flex-1 space-y-1">
                      <h3 className="text-lg font-medium leading-6 text-gray-900">
                        Abstraction
                      </h3>
                      <p className="text-base leading-6 text-gray-500">
                        This resource covers the concept of abstraction in OOP,
                        which is the process of hiding the implementation
                        details of a class and showing only the necessary
                        information to the user.
                      </p>
                      <p className="mt-1 text-sm leading-5 text-gray-500">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://www.geeksforgeeks.org/abstraction-in-java/"
                          className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                        >
                          Learn more &rarr;
                        </a>
                      </p>
                    </div>
                  </div>
                </li>
              }

              <li className="py-4">
                <div className="flex-1 space-y-1">
                  <h3 className="text-lg font-medium leading-6 text-gray-900">
                    Inheritance
                  </h3>
                  <p className="text-base leading-6 text-gray-500">
                    This resource covers inheritance, which is a concept in OOP
                    where a new class is created from an existing class.
                  </p>
                  <p className="mt-1 text-sm leading-5 text-gray-500">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.geeksforgeeks.org/inheritance-in-java/"
                      className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                    >
                      Learn more &rarr;
                    </a>
                  </p>
                </div>

                {/* </div> */}
              </li>
              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Polymorphism
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers polymorphism, which is a concept in
                      OOP where a single method or object can have multiple
                      forms.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.geeksforgeeks.org/polymorphism-in-java/"
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OOPS;
